import { useLayoutEffect } from "react";

import { reloadPage } from "../../utils";
import { Spinner } from "../../components";

import styles from "./Developers.module.scss";

const Developers = () => {
    useLayoutEffect(function redirectToRubyPage() {
        if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
          // window.location.replace(`http://localhost:3001${window.location.pathname}`);
        } else {
          window.history.pushState('service_react', '', window.location.pathname);
          // window.history.back();
          reloadPage();
        }
      });

      return <div className={styles.Root}>
            <Spinner />
      </div>
}

export default Developers;
